module.exports = __webpack_public_path__ + "img/rec-19.690fa8e1.png";